import { connect } from 'react-redux'
import { useEffect } from 'react'
import * as Redux from 'redux'
import { useParams } from 'react-router'
import ClientFirearmActions from '@ClientActions/firearm.action'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
import { CommonService } from '@Services/common.service'
import AddFirearm from '../add-firearm/add-firearm'

const DetailFirearm = (props: any) => {
    const { getDetail, detail } = props
    const params = useParams()
    const { id }: any = params

    useEffect(() => {
        getDetail(id)
    }, [id])

    return (
        <div className="page-detail-firearm">
            {/* <PageHeader title="Detail Firearm" textName={detail?.status} /> */}
            <PageHeader
                title={
                    `Detail ${CommonService.textCapitalize(detail?.type)}` || ''
                }
                textName={detail?.status}
            />
            <AddFirearm isDetailPage productDetail={detail} detailId={id} />
        </div>
    )
}

const mapStateToProps = (store: any) => {
    return {
        detail: store?.client.firearms?.firearmDetail,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    return {
        getDetail: (id: string) =>
            dispatch(
                ClientFirearmActions.getFirearmDetail('FIREARM', id) as any
            ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailFirearm)
